import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataStudioIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M28.68 19.0675C28.16 18.8941 27.5867 19.1875 27.4267 19.7075C25.8133 24.6675 21.2267 28.0008 16.0133 28.0008C9.4 28.0008 4.01333 22.6141 4.01333 16.0008C4.01333 10.7608 7.36 6.17414 12.3467 4.57414C12.8667 4.4008 13.16 3.8408 12.9867 3.3208C12.8133 2.8008 12.2533 2.50747 11.7333 2.6808C5.90667 4.53414 2 9.89414 2 16.0008C2 23.7208 8.28 30.0008 16 30.0008C22.0933 30.0008 27.44 26.1075 29.32 20.3208C29.4933 19.8008 29.2 19.2275 28.68 19.0675Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 2C15.4533 2 15 2.45333 15 3V16C15 16.5467 15.4533 17 16 17H29C29.5467 17 30 16.5467 30 16C30 8.28 23.72 2 16 2ZM17 15V4.04C22.8267 4.52 27.48 9.17333 27.96 15H17Z",
      fill: "currentColor"
    })]
  });
};
export default DataStudioIcon;